import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';

import { BannerModel } from '../models/banner.model';

import { environment } from '../../../environments/environment';

@Injectable()
export class BannerService {

  constructor(public http: HttpClient) {

  }

  collection(id: number): Promise<Array<BannerModel>> {
    const arrayModel: BannerModel[] = [];

    return new Promise<Array<BannerModel>>((resolve, reject) => {
      this.fetchAll(id).subscribe(res => {
        for (const monitoraItem of res.data) {
          arrayModel.push(this.populate(monitoraItem));
        }
        resolve(arrayModel);
      }, err => {
        reject(err);
      })
    })
  }


  populate(data: any): BannerModel {
    return new BannerModel(data.id, data.name, data.value, data.assessment_id, data.trilha_id, data.page, data.type);
  }

  fetchAll(id: number): Observable<any> {
    return this.http.get(environment.baseUrl + '/api/v2/client/banner/folder/' + id, this.getHeaders());
  }

  save(banner: any, id: number): Observable<any> {
    return this.http.post(environment.baseUrl + '/api/v2/client/banner/folder/' + id, banner, this.getHeaders());
  }

  delete(id: number): Observable<any> {
    return this.http.delete(environment.baseUrl + '/api/v2/client/manager/banner/' + id, this.getHeaders());
  }

  folderAll(): Observable<any> {
    return this.http.get(environment.baseUrl + '/api/v2/client/manager/banner', this.getHeaders()); //
  }

  folderDelete(params: number): Observable<any> {
    return this.http.delete(environment.baseUrl + '/api/v2/client/banner/folder/delete/' + params, this.getHeaders());
  }

  folderPost(data: any): Observable<any> {
    return this.http.post(environment.baseUrl + '/api/v2/client/manager/banner', this.getHeaders()); //
  }

  getItem(params: number): Observable<any> {
    return this.http.get(environment.baseUrl + '/api/v2/client/manager/banner/' + params, this.getHeaders());  //
  }

  update(banner: any): Observable<any> {
    return this.http.put(environment.baseUrl + '/api/v2/client/manager/banner/' + banner.id, this.getHeaders()); //
  }

  getTrails(): Observable<any> {
    return this.http.get(environment.baseUrl + '/api/v2/client/banner/trilha', this.getHeaders());
  }

  getAssessments(): Observable<any> {
    return this.http.get(environment.baseUrl + '/api/v2/client/banner/assessment', this.getHeaders());
  }

  linkmenu(): Observable<any> {
    return this.http.get(environment.baseUrl + '/api/v2/client/banner/menu', this.getHeaders());
  }

  trailView(id: number): Observable<any> {
    const data = {
      trilha_id: id
    }
    return this.http.post(environment.baseUrl + '/api/v2/client/trilha/view', data, this.getHeaders());
  }

  getHeaders(): { headers: HttpHeaders } {
    const token = sessionStorage.getItem('token');
    const headerOptions = {
      'Authorization': token,
      'Accept': 'application/json'
    };
    return { headers: new HttpHeaders(headerOptions) };
  }

}



// WEBPACK FOOTER //
// ./src/app/@core/services/banner.service.ts